import Axios from "axios";
const baseURL = process.env.BARRAMUNDI;
export default {
    async getClinicHours() {
        const res = await Axios.get(`${baseURL}/account/clinic-hour`);
        if (res && res.data && res.data.response) {
            return res.data.response.resources;
        }
        return null;
    },
    async updateClinicHours(clinicHours) {
        return Axios.put(`${baseURL}/account/clinic-hour`, clinicHours).then(
            res => {
                if (res && res.data && res.data.response) {
                    return res.data.response;
                }
                return null;
            }
        );
    },

    // new version
    async getClinicHoursV2() {
        return Axios.get(`${baseURL}account/clinic-hour-v2`).then(
            response => response.data
        );
    },
    async toggleClinicDay(dayId, isOn) {
        return Axios.put(
            `${baseURL}account/clinic-day-on-off/${dayId}/${isOn}`
        ).then(response => response.data);
    },
    async createClinicHour(params) {
        return Axios.post(`${baseURL}account/clinic-hour`, params).then(
            response => response.data
        );
    },
    async updateClinicHour(hourId, params) {
        return Axios.put(
            `${baseURL}account/clinic-hour-v2/${hourId}`,
            params
        ).then(response => response.data);
    },
    async deleteClinicHour(hourId) {
        return Axios.delete(`${baseURL}account/clinic-hour/${hourId}`).then(
            response => response.data
        );
    }
};
